import { useAppSelector } from "@/shared/lib/redux"
import { selectPartnersStatisticsAggregates } from "../../model"
import { toLocaleString } from "@/shared/lib/to-locale-string"

export const FizStatistics = () => {
    const statistics = useAppSelector(selectPartnersStatisticsAggregates)

    return (
        <div className='box'>
            <div className="box_header mb-5 screen:mb-6">
                Физические лица
            </div>
            <div className="flex items-center pb-4 screen:pb-[18px] mb-5 screen:mb-6 border-b border-[#ccc]">
                <div className="screen:text-lg text-base">Количество клиентов:</div>
                <div className="font-semibold text-2xl screen:text-[32px] pl-2 leading-[24px] screen:leading-[32px]">{toLocaleString(statistics.countClientsFiz ?? 0)}</div>
            </div>
            <div className="flex items-center pb-4 screen:pb-[18px] mb-5 screen:mb-6 border-b border-[#ccc]">
                <div className="screen:text-lg text-base">Количество транзакций:</div>
                <div className="font-semibold text-2xl screen:text-[32px] pl-2 leading-[24px] screen:leading-[32px]">{toLocaleString(statistics.countTransactionsFiz ?? 0)}</div>
            </div>
            <div className="flex items-center pb-4 screen:pb-[18px] mb-5 screen:mb-6 border-b border-[#ccc]">
                <div className="screen:text-lg text-base">Сумма транзакций:</div>
                <div className="font-semibold text-2xl screen:text-[32px] pl-2 leading-[24px] screen:leading-[32px]">{toLocaleString(statistics.totalFiz ?? 0)} ₽</div>
            </div>
            <div className="flex items-center pb-4 screen:pb-[18px] border-b border-[#ccc]">
                <div className="screen:text-lg text-base">Бонусные скидки:</div>
                <div className="font-semibold text-2xl screen:text-[32px] pl-2 leading-[24px] screen:leading-[32px]">{toLocaleString(statistics.bonusTotalFiz ?? 0)} ₽</div>
            </div>
        </div>
    )
}